module.exports = __webpack_public_path__ + "img/casa.8db0483a.png";